import { useQuery } from '@tanstack/react-query';
import { getLastRunForInspection } from '../services/IIMRunsService';
export default function useGetLastRunForInspection(inspectionId) {
    return useQuery({
        queryKey: ['iim-last-run', inspectionId],
        queryFn: () => getLastRunForInspection(inspectionId),
        staleTime: 5 * 60 * 1000,
        cacheTime: 30 * 60 * 1000,
        retry: 3
    });
}
